/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';
import { DMCommonModule } from 'app/common/dm-common.module';
import { FileSystemGuideModule } from 'app/feature/service/file-service/file-system/file-system-guide/file-system-guide.module';

import { AddClientNfsShareComponent } from './add-client-nfs-share.component';

@NgModule({
    declarations: [AddClientNfsShareComponent],
    exports: [AddClientNfsShareComponent],
    imports: [
        CommonModule,
        CoreModule,
        ReactiveFormsModule,
        FormsModule,
        DMCommonModule,
        FileSystemGuideModule,
    ],
})
export class AddClientNfsShareModule { }
